import { api } from '@/fsd/shared/api';

interface IParams {
  challenge_id: string;
  code: string;
  new_password: string;
}

export const authPasswordResetConfirm = async (data: IParams) => {
  return await api.post('/api/v1/auth/password/reset/confirm/', {
    body: { ...data },
    notify: {
      error: true,
      success: true,
    },
  });
};
